import {Box, Container} from '@mui/material';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import {ImageTextBlock} from '../index';
import ImageTextTop from '../imageTextBlock/ImageTextTop';
import ImageTextService from '../imageTextBlock/ImageTextService';
import ImageTextCard from '../imageTextBlock/ImageTextCard';

const ImageText = ({imageText}) => {
  const {mode} = useDarkMode();
  const renderTextBlock = imageText => {
    const final = [];
    switch (imageText.lien?.text) {
      case 'accueil':
        final.push(<ImageTextTop image_text={imageText} />);
        break;
      case 'who':
        final.push(<ImageTextService image_text={imageText} />);
        break;
      case 'card':
        final.push(<ImageTextCard image_text={imageText} />);
        break;
      default:
        final.push(<ImageTextBlock image_text={imageText} />);
    }
    return final;
  };
  return (
    <Box style={{backgroundColor: mode.settings.backgroundColor2}} py={3} id={imageText.lien?.text}>
      <Container maxWidth={'lg'}>{renderTextBlock(imageText)}</Container>
    </Box>
  );
};

export default ImageText;
